import { useCallback, useRef, useState } from 'react';
import { InView } from 'react-intersection-observer';

import { RiArrowUpLine as ArrowUpwardIcon } from '@remixicon/react';

import { Button } from '@spotify-internal/encore-web';

import styles from './ScrollTopButton.module.css';

type Props = {
  label?: string;
};

export const ScrollTopButton = ({ label = 'Back to top' }: Props) => {
  const [showButton, setShowButton] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const scrollToTop = useCallback(() => {
    if (!ref?.current) return;
    try {
      const container = ref.current.parentNode as HTMLElement;
      container?.scrollTo({ top: 0, behavior: 'smooth' });
    } catch {
      // Ignore scroll errors for browser compatibility
    }
  }, []);

  return (
    <>
      <div ref={ref} />
      <InView onChange={inView => setShowButton(!inView)}  data-track-source-anchor="511746f0a3;scroll-top-button-in-view"/>
      {showButton && (
        <div className={styles.wrapper}>
          <Button
            variant="tertiary"
            size="medium"
            semanticColor="textBase"
            isFloating
            onClick={scrollToTop}
           data-track-source-anchor="a52fa123d1;scroll-top-button">
            <ArrowUpwardIcon className={styles.icon} />
            {label}
          </Button>
        </div>
      )}
    </>
  );
};
